module.exports = __webpack_public_path__ + "static/media/screen01.6fb100ff.png";